import { type FC } from 'react';
import cx from 'classnames';

import { type VoidFunction } from 'src/lib/types';

import { Actions } from './components/Actions';
import { PromptField } from './views/PromptField';
import { RecentlyUsedTemplates } from './views/RecentlyUsedTemplates';
import styles from './styles.module.scss';
import { useHandlers } from './useHandlers';
import { useViewState } from './useViewState';

export interface NewProjectPromptWidgetProps {
  className?: string;
  onFlowFinished?: VoidFunction;
  inPopupMode?: boolean;
}

export const NewProjectPromptWidget: FC<NewProjectPromptWidgetProps> = ({
  className,
  onFlowFinished,
  inPopupMode,
}) => {
  const { classifyingTemplate, editorType } = useViewState();

  const { handleWidgetAction } = useHandlers({
    onFlowFinished,
    inPopupMode,
    editorType,
  });

  return (
    <div
      className={cx(styles.root, className)}
      data-testid="newProjectPromptWidget"
    >
      <PromptField onWidgetAction={handleWidgetAction} />

      <Actions
        className={styles.actions}
        onAction={handleWidgetAction}
        disabled={classifyingTemplate}
      />

      <RecentlyUsedTemplates
        className={styles.recentlyUsedTemplates}
        onWidgetAction={handleWidgetAction}
      />
    </div>
  );
};
